module.exports = __webpack_public_path__ + "static/media/icon_ticket.7a30836a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_ticket.svg
// module id = 86
// module chunks = 0